module.exports = "<!-- <div *ngIf=\"!isJudiciary\"> -->\n<div>\n  <app-dashboard-finance>\n  </app-dashboard-finance>\n</div>\n\n<!-- <div *ngIf=\"isJudiciary\">\n  <app-dashboard-judiciary>\n  </app-dashboard-judiciary>\n</div> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/dashboard/dashboard.component.html
// module id = ./src/app/views/dashboard/dashboard.component.html
// module chunks = main